import React, { useState, useEffect } from 'react';
import {
  Topbar,
} from '@components';
import { useNavigate, useParams } from 'react-router-dom';
import {
  RootContainer,
  Title,
  Top,
  Image,
  Loader,
  PlayerListContainer,
  PlayerBox,
  Number,
  DataContainer,
  NameAndAmountContainer,
  PlayerName,
  Amount,
  PhoneNumberContainer,
  PhoneNumber,
} from './TopWinners.style';
import { Spin } from 'antd';
import { PUBLIC_ROUTE } from '@router/route.constants';
import { api } from '@api';
import {
  BURMESE_LANGUAGE_CODE_LK,
  CHINESE_LANGUAGE_CODE_LK,
  WINNER_GAMES_LK,
} from '@constants';
import { useSelector } from 'react-redux';
import { getFormattedNumber } from '@utils';
import { useTranslation } from 'react-i18next';

const TopWinners = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const { child_game_id } = useParams();
  const lang = useSelector(state => state.app.userPreferedLanguage);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [game, setGame] = useState({});

  useEffect(() => {
    getWinners();

    // eslint-disable-next-line
  }, []);

  const getWinners = () => {
    setLoading(true);
    api
      .getWinners({
        child_game_id,
      })
      .then(({ winners, child_game }) => {
        setLoading(false);
        const _game = parseData([{ ...child_game }])[0];
        setGame(_game);
        setData(winners);
      })
      .catch(() => { });
  }

  /**
   * get game names and icons 
   * based on current app language
   */
  const parseData = (games) => {
    return games.map(item => {
      return {
        ...item,
        icon: lang === CHINESE_LANGUAGE_CODE_LK
          ? item.icon_ch
          : lang === BURMESE_LANGUAGE_CODE_LK
            ? item.icon_mm
            : item.icon_en,
        name: lang === CHINESE_LANGUAGE_CODE_LK
          ? item.name_ch
          : lang === BURMESE_LANGUAGE_CODE_LK
            ? item.name_mm
            : item.name_en,
      }
    });
  }

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.POPULAR}/${WINNER_GAMES_LK}`);
  }

  const renderTop = () => (
    <Top>
      <Image src={game.icon} />
    </Top>
  );

  return (
    <>
      <Topbar
        title={game.name}
        goBack={goBack}
      />
      <RootContainer>
        {loading && (
          <Loader>
            <Spin />
          </Loader>
        )}
        {!loading &&
          <>
            {renderTop()}
            <Title>
              {t("topWinner.topWinnerSubtitle")}
            </Title>

            <PlayerListContainer>
              {data.map((data, index) => (
                <PlayerBox key={index} first={index === 0 ? 'true' : 'false'}>
                  <Number>
                    {index + 1}.
                  </Number>
                  <DataContainer>
                    <NameAndAmountContainer>
                      <PlayerName> {data.name} </PlayerName>
                      <Amount>{`${getFormattedNumber(data.amount)}`} Ks. </Amount>
                    </NameAndAmountContainer>
                    <PhoneNumberContainer>
                      <PhoneNumber> {data.phone} </PhoneNumber>
                    </PhoneNumberContainer>
                  </DataContainer>
                </PlayerBox>
              ))}
            </PlayerListContainer>
          </>
        }
      </RootContainer>
    </>
  );
}

export default TopWinners;